/* eslint-disable react/self-closing-comp */
import React from "react";

const Loading: React.FC = () => {
    return (
        <div id="loading-container-id" className="container-none">
            <span className="custom-loader"></span>
            <p style={{ fontSize: "18px" }}>Carregando</p>
        </div>
    );
};

export default Loading;
